import { Loader } from '@googlemaps/js-api-loader';
import domReady from '@wordpress/dom-ready';

function centerMap(map, google) {
  // Create map boundaries from all map markers.
  const bounds = new google.maps.LatLngBounds();
  map.markers.forEach(function (marker) {
    bounds.extend({
      lat: marker.position.lat(),
      lng: marker.position.lng(),
    });
  });

  // Case: Single marker.
  if (1 === map.markers.length) {
    map.setCenter(bounds.getCenter());
    // Case: Multiple markers.
  } else {
    map.fitBounds(bounds);
  }
}

function initMarker(marker, map, google) {
  const { lat, lng, pin } = marker.dataset;
  const latLng = {
    lat: parseFloat(lat),
    lng: parseFloat(lng),
  };

  // Create marker instance.
  const newMarker = new google.maps.Marker({
    position: latLng,
    map,
    icon: pin,
  });

  // Append to reference for later use.
  map.markers.push(newMarker);

  // If marker contains HTML, add it to an infoWindow.
  if (marker.innerHTML) {
    // Create info window.
    const infowindow = new google.maps.InfoWindow({
      content: marker.innerHTML,
    });

    // Show info window when marker is clicked.
    google.maps.event.addListener(newMarker, 'click', function () {
      infowindow.open(map, newMarker);
    });
  }
}

function initMap(mapElement, mapStyle, google) {
  const mapOptions = {
    center: {
      lat: parseInt(mapElement.getAttribute('data-lat')),
      lng: parseInt(mapElement.getAttribute('data-lng')),
    },
    disableDefaultUI: true,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    zoom: parseInt(mapElement.getAttribute('data-zoom')) || 9,
    styles: JSON.parse(mapStyle),
  };
  const markers = mapElement.querySelectorAll('.google-map__marker');
  const map = new google.maps.Map(mapElement, mapOptions);

  if (0 < markers.length) {
    map.markers = [];
    markers.forEach(function (marker) {
      initMarker(marker, map, google);
    });
    centerMap(map, google);
  }

  return map;
}

domReady(() => {
  const mapSettings = window.mapSettings;
  const mapElements = document.querySelectorAll('.google-map__acf-map');
  const loader = new Loader({
    apiKey: mapSettings.api_key,
  });

  if (0 < mapElements.length) {
    loader.load().then((google) => {
      mapElements.forEach(function (mapElement) {
        initMap(mapElement, mapSettings.styles, google);
      });
    });
  }
});
